import type { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { useFieldUsers } from './useFieldUsers'
import type { WorkflowField } from '../types'
import { isApprovalsWorkflowField } from '../utils/isApprovalsWorkflowField'

/**
 * Displays approval groups and their complete approver lists for approvals fields.
 */
export function useExpandOptions(): ExpandOptions<WorkflowField> {
  const { userLabel, usersById, userTooltip } = useFieldUsers()

  return {
    expandable: isApprovalsWorkflowField,
    render: (field) => ({
      custom: isApprovalsWorkflowField(field)
        ? [
            {
              type: 'fields',
              title: field.settings.customizeOptionLabel?.enabled
                ? field.settings.customizeOptionLabel.plural
                : 'Options',
              fields: field.settings.options
                .filter(({ deleted }) => deleted === null)
                .map(({ approverIds, label, tooltip }) => ({
                  type: 'tags',
                  label,
                  help: tooltip ?? undefined,
                  tags: approverIds.map((approverId) => ({
                    strikethrough: !usersById.has(approverId),
                    text: userLabel(approverId),
                    tooltip: userTooltip(approverId),
                  })),
                })),
            },
          ]
        : undefined,
    }),
  }
}
